import React, { useEffect, useRef, useState } from "react";

import { useSelector } from "react-redux";

// Table component dependency

import { GetCreateTable, GetListForm } from "../../core/Helper2";
import { WebSearchHelperService } from "../tools/search-helper";
import { TopToolBar } from "../../core/TopToolbar";
import { GetThaiZoneDate, IsNullOrEmptyObject } from "../../core/Helper";

export const DefaultState = {
  size: "sm",
  show: false,
  fieldId: "",
  fieldName: "",
  columns: [],
  sql: {
    tableName: null,
    fields: [],
    criteriaFields: [],
    criteriaText: "",
    defaultCriteria: "",
    orderBy: [],
    maxRows: 3000,
  },
  action: (e) => {
    alert(e);
  },
};
export default function SearchBigData(props) {
  const userDetail = useSelector((state) => state.user.detail);
  const [winState, setWinState] = props.winState;
  const { disableEmpty, onAddNew, comment, autoFirstPage, dateFilter } = props;
  const textRef = useRef(null);

  const [data, setData] = useState([]);
  const [table, setTable] = useState(null);
  //----------------------------------------------------------------------
  useEffect(() => {
    if (winState?.show) {
      document.removeEventListener("dblclick", null);
      textRef.current.focus();

      if (winState?.autoFirstPage || autoFirstPage) {
        if (!IsNullOrEmptyObject(dateFilter)) {
          getData("", [new Date(), new Date()]);
        }
      }
      return () => {
        document.addEventListener("dblclick", null);
        setData([]);
      };
    }
  }, [winState?.show]);

  //----------------------------------------------------------------------
  const getData = async (text, dates) => {
    winState.sql.criteriaText = text;
    let ddates = [new Date(), new Date()];
    if (dates) {
      ddates[0] = GetThaiZoneDate(dates[0]);
      ddates[1] = GetThaiZoneDate(dates[1]);
    }

    winState.sql.criteriaDateRanges = ddates ?? null;
    let res = await WebSearchHelperService.GetList({
      Params: winState.sql,
      User: userDetail,
    });

    if (res) {
      setData(res.data);
    }
  };
  //----------------------------------------------------------------------
  useEffect(() => {
    if (winState?.show && data) {
      setTable(
        GetCreateTable({
          idFieldName: winState?.fieldId ?? "id",
          columns: winState?.columns,
          rowEvents: rowEvents,
          data: data ?? [],
        })
      );
    }
  }, [data, winState]);

  //----------------------------------------------------------------------
  const rowEvents = {
    onDoubleClick: (e, row, rowIndex) => {
      e.preventDefault();
      winState.action(row, winState);
    },
  };
  //----------------------------------------------------------------------
  return (
    <>
      <GetListForm
        {...{
          list: [winState, setWinState],
          size: "lg",
          title: winState?.title ?? "ค้นหา",
        }}
      >
        <TopToolBar
          onAddNew={onAddNew}
          searchHandler={(text, dates) => getData(text, dates)}
          refTo={textRef}
          disableEmpty={disableEmpty || winState?.disableEmpty}
          dateFilter
        ></TopToolBar>
        {comment}
        {table}
      </GetListForm>
    </>
  );
}
